module.exports = __webpack_public_path__ + "img/join4-1.f021b62d.svg";